/*
 * Copyright © 2018 Aram Meem Company Limited.  All Rights Reserved.
 */

import 'whatwg-fetch';
import { DeliveryAddress } from './models/delivery-address';
import { OrderTracking } from './models/order-tracking';
import { getXHRPath } from './xhr-route';

export class ApiService {

  public static handleFetchResponse = response => {
    if (response.ok) {
      return response.json();
    } else {
      return Promise.reject(response);
    }
  };

  public static fetchWrapper<T>(path: string): Promise<T> {
    return fetch(getXHRPath(path))
      .then(ApiService.handleFetchResponse)
  }

  public static getOrderByTrackingOrderNumber(trackingNumber: string): Promise<OrderTracking> {
    return ApiService.fetchWrapper<OrderTracking>(`/delivery/public/v2/orders/${trackingNumber}`);
  }

  public static updateDropOffLocation(trackingNumber: string, deliveryAddress: DeliveryAddress): Promise<any> {
    return fetch(getXHRPath(`/delivery/public/v1/orders/${trackingNumber}/dropoff`), {
      method: 'PUT',
      // tslint:disable-next-line:object-literal-sort-keys
      headers: {
        "Accept": "application/json",
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(deliveryAddress)
    }).then(response => {
      if (response.ok) {
        return Promise.resolve(true);
      } else {
        return Promise.reject(response);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/api.service.ts